import { ref } from "vue";
import axios from "axios";
export default {
  data() {
    return {
      tipsRadio: 0,
      percent1: 0,
      percent2: 0,
      percent3: 0,
      loadingTips: false
    };
  },
  props: {
    totalPrice: Number,
    id: Number
  },
  methods: {
    percent() {
      this.percent1 = Math.round(this.totalPrice * 0.05);
      this.percent2 = Math.round(this.totalPrice * 0.1);
      this.percent3 = Math.round(this.totalPrice * 0.15);
    },
    async postTips(info) {
      try {
        this.loadingTips = true;
        const {
          data
        } = await axios.post(`https://c2ff7a8de0a119c8.mokky.dev/tips`, {
          tips: info,
          orders_id: this.id
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingTips = false;
        this.$emit('hideTips', false);
      }
    },
    submitForm() {
      if (this.form.tips) {
        this.ruleFormRef.validate(valid => {
          if (valid) {
            this.postTips(this.form.tips);
            this.form.tips = "";
          } else {
            return false;
          }
        });
      } else {
        this.postTips(this.tipsRadio);
      }
    }
  },
  mounted() {
    this.percent();
    this.tipsRadio = this.percent3;
  },
  setup() {
    const ruleFormRef = ref({});
    const form = ref({
      tips: ""
    });

    // кастомное правило
    const checkNumber = (rule, value, callback) => {
      if (!Number.isInteger(value) && value) {
        callback(new Error("Введите число!"));
      } else {
        if (value <= 0 && value) {
          callback(new Error("Недопустимая сумма!"));
        } else {
          callback();
        }
      }
    };
    const rules = ref({
      tips: [{
        validator: checkNumber,
        trigger: "blur"
      }]
    });
    return {
      ruleFormRef,
      form,
      rules
    };
  }
};